import { CustomNoRowsOverlayProps } from "ag-grid-react";

interface NoRowsOverlayParams {
  message: string;
}

const NoRowsOverlay = ({ message }: CustomNoRowsOverlayProps & NoRowsOverlayParams) => (
  <div
    className="flex h-full items-center justify-center p-8"
    data-entity-preview-empty-state="table"
  >
    <div className="text-sm text-gray-500">{message}</div>
  </div>
);

export default NoRowsOverlay;
